import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

const AUTO_PREFETCH_MAX_AGE_MS = 12 * 60 * 60 * 1000;

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
.home-container {
  padding: 3rem 4rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  background-color: #FBFDFD;
  font-family: "Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.home-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.home-header .greeting-box .greeting-text {
  font-size: 3rem;
  font-weight: 800;
  color: #1C1B1F;
  letter-spacing: -0.04em;
  margin-bottom: 0.75rem;
}
.home-header .greeting-box .sub-text {
  font-size: 1.25rem;
  font-weight: 500;
  color: #49454F;
  letter-spacing: -0.01em;
}

.header-stats {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  background-color: #FFFFFF;
  padding: 1.25rem 2rem;
  border-radius: 20px;
  border: 1px solid #E0E2E6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}
.header-stats .stat-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.header-stats .stat-item .label {
  font-size: 0.8125rem;
  color: #49454F;
  font-weight: 700;
}
.header-stats .stat-item .value {
  font-size: 1.5rem;
  font-weight: 800;
  color: #1C1B1F;
  letter-spacing: -0.02em;
}
.header-stats .stat-item .value.highlight {
  color: #1A73E8;
}
.header-stats .divider {
  width: 1px;
  height: 32px;
  background-color: #E0E2E6;
}

.action-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.5rem;
  flex: 1;
}

.md-card {
  position: relative;
  border-radius: 36px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
  display: flex;
  flex-direction: column;
}
.md-card.card-primary {
  background-color: #D3E3FD;
  color: #041E49;
}
.md-card.card-primary .icon-surface {
  background-color: #E8F0FE;
}
.md-card.card-primary .icon-surface i {
  color: #1A73E8;
}
.md-card.card-secondary {
  background-color: #F2F2F2;
  color: #1D1B20;
}
.md-card.card-secondary .icon-surface {
  background-color: #FFFFFF;
}
.md-card.card-secondary .icon-surface i {
  color: #49454F;
}
.md-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.06);
}
.md-card:hover.card-primary {
  background-color: #C2D7F7;
}
.md-card:hover.card-secondary {
  background-color: #E8E8E8;
}
.md-card:active {
  transform: scale(0.98);
}
.md-card .card-content {
  padding: 3.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 2;
}
.md-card .icon-surface {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  transition: transform 0.3s;
}
.md-card .icon-surface i {
  font-size: 2.25rem;
}
.md-card:hover .icon-surface {
  transform: scale(1.1);
}
.md-card .text-group {
  flex: 1;
}
.md-card .text-group h3 {
  font-size: 2.25rem;
  font-weight: 800;
  margin-bottom: 1.25rem;
  letter-spacing: -0.03em;
}
.md-card .text-group p {
  font-size: 1.125rem;
  line-height: 1.6;
  color: inherit;
  opacity: 0.7;
  font-weight: 500;
  margin: 0;
}
.md-card .card-footer {
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 1.0625rem;
  letter-spacing: -0.01em;
}
.md-card .card-footer i {
  font-size: 0.8125rem;
  transition: transform 0.2s;
}
.md-card:hover .card-footer i {
  transform: translateX(6px);
}

.home-footer .footer-card {
  background-color: #FFFFFF;
  border: 1px solid #E0E2E6;
  border-radius: 20px;
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}
.home-footer .footer-card .info-icon {
  width: 48px;
  height: 48px;
  background-color: #F1F3F4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-footer .footer-card .info-icon i {
  color: #49454F;
  font-size: 1.25rem;
}
.home-footer .footer-card .info-text {
  display: flex;
  flex-direction: column;
}
.home-footer .footer-card .info-text .title {
  font-size: 1.0625rem;
  font-weight: 800;
  color: #1C1B1F;
  margin-bottom: 0.25rem;
}
.home-footer .footer-card .info-text .desc {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #49454F;
}

.card-overlay {
  position: absolute;
  inset: 0;
  transition: opacity 0.5s ease;
  opacity: 0.4;
}

.accent-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  transition: height 0.3s ease;
}

.inspection-card .card-overlay {
  background: radial-gradient(circle at top right, rgba(37, 99, 235, 0.2), transparent);
}
.inspection-card .accent-line {
  background: #2563eb;
}
.inspection-card .icon-circle {
  background: rgba(37, 99, 235, 0.1);
  border: 1px solid rgba(37, 99, 235, 0.2);
}
.inspection-card .icon-circle i {
  color: #3b82f6;
}
.inspection-card:hover .accent-line {
  height: 8px;
}
.inspection-card:hover .icon-circle {
  background: #2563eb;
}
.inspection-card:hover .icon-circle i {
  color: white;
}

.checklist-card .card-overlay {
  background: radial-gradient(circle at top right, rgba(16, 185, 129, 0.2), transparent);
}
.checklist-card .accent-line {
  background: #10b981;
}
.checklist-card .icon-circle {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.2);
}
.checklist-card .icon-circle i {
  color: #10b981;
}
.checklist-card:hover .accent-line {
  height: 8px;
}
.checklist-card:hover .icon-circle {
  background: #10b981;
}
.checklist-card:hover .icon-circle i {
  color: white;
}

.card-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.icon-area {
  margin-bottom: auto;
}
.icon-area .icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.icon-area .icon-circle i {
  font-size: 2.25rem;
}

.text-area {
  margin-bottom: 2rem;
}
.text-area h2 {
  font-size: 2.5rem;
  font-weight: 900;
  color: white;
  margin-bottom: 0.75rem;
  letter-spacing: -0.02em;
}
.text-area p {
  font-size: 1.125rem;
  color: #64748b;
  font-weight: 500;
  line-height: 1.6;
  max-width: 80%;
}

.action-area {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.action-area span {
  font-size: 0.875rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  color: white;
}
.action-area i {
  font-size: 0.75rem;
  color: white;
  transition: transform 0.3s ease;
}

.card-item:hover .action-area i {
  transform: translateX(5px);
}

@media screen and (orientation: portrait) {
  .home-content {
    gap: 2rem;
  }
  .card-grid {
    grid-template-columns: 1fr;
  }
  .card-item {
    height: 320px;
    padding: 2.5rem;
  }
  .header-section .main-title span:nth-child(2) {
    font-size: 3rem;
  }
  .text-area h2 {
    font-size: 2rem;
  }
}
@media screen and (max-height: 800px) and (orientation: landscape) {
  .home-container {
    padding: 2rem;
  }
  .home-content {
    gap: 2rem;
  }
  .card-item {
    height: 360px;
    padding: 2.5rem;
  }
  .header-section .main-title span:nth-child(2) {
    font-size: 3rem;
  }
}`],
})
export class PageHomeComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service)         public service: Service,@Inject( CDR)         public ref: CDR,@Inject( Router    )         public router: Router    ) { }

    public user: any = null;
    public selectedProjects: any[] = [];

    private _unsubNetwork: (() => void) | null = null;
    private _maintenanceRunning: boolean = false;

    public async ngOnInit() {
        await this.service.init(this);
        this.initAutoMaintenance();
        
        try {
            const { code, data } = await wiz.call("init", {});
            if (code === 200) {
                this.user = data.user;
                this.selectedProjects = Array.isArray(data.selected_projects) ? data.selected_projects : [];
            }
        } catch (e) {
            console.error("Home init error:", e);
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }

        await this.startAutoMaintenance();
    }

    public ngOnDestroy() {
        if (this._unsubNetwork) this._unsubNetwork();
    }

    private initAutoMaintenance() {
        if (!wiz.offline) return;
        this._unsubNetwork = wiz.offline.network.onStatusChange(async (status: string) => {
            if (status === 'online') {
                await this.startAutoMaintenance();
            }
        });
    }

    private isOnline(): boolean {
        return !!(wiz.offline?.isOnline ? wiz.offline.isOnline() : navigator.onLine);
    }

    private async startAutoMaintenance() {
        if (this._maintenanceRunning || !wiz.offline || !this.isOnline()) {
            return;
        }

        this._maintenanceRunning = true;
        try {
            await this.autoSync();
            await this.autoPrefetchSelectedProjects();
        } finally {
            this._maintenanceRunning = false;
        }
    }

    private async autoSync() {
        const pendingSync = await wiz.offline.pendingSync();
        if (pendingSync <= 0) return;

        try {
            await wiz.offline.forcSync();
        } catch (error) {
            console.error('Auto sync failed:', error);
        }
    }

    private async autoPrefetchSelectedProjects() {
        if (!this.selectedProjects.length || !this.isOnline()) return;

        for (const project of this.selectedProjects) {
            const projectId = String(project?.id || '');
            if (!projectId || !this.isOnline()) continue;

            try {
                const manifest = await wiz.offline.prefetch.getManifest(projectId);
                if (!this.shouldPrefetch(manifest)) continue;
                await wiz.offline.prefetch.prefetchProject(projectId);
            } catch (error) {
                console.error('Auto prefetch failed:', projectId, error);
            }
        }
    }

    private shouldPrefetch(manifest: any): boolean {
        if (!manifest) return true;
        const updatedAt = Number(manifest.updated_at || manifest.completed_at || 0);
        const blockingItems = Number(manifest.blocking_items ?? 0);
        if (manifest.status !== 'completed' || blockingItems > 0) return true;
        if (!updatedAt) return true;
        return Date.now() - updatedAt > AUTO_PREFETCH_MAX_AGE_MS;
    }

    public goToInspection() {
        this.service.href('/inspection');
    }

    public goToChecklist() {
        this.service.href('/checklist');
    }
}

export default PageHomeComponent;